import React, { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../App';
import { Link } from 'react-router-dom';
import PostTemplate from './PostTemplate';
import ReactPaginate from 'react-paginate';
import "./Home.css"
import Navbar from './Navbar';
import END_POINT from '../../END_POINT';

const Home = () => {
    const userContext = useContext(UserContext);
    const [user, setUser] = useState(userContext);
    const [post, setPost] = useState([]);
    const [post1, setPost1] = useState([]);


    // pagination
    const usersPerPage=3
    const pageCount=Math.ceil(post1.length/3)
    const [pageNumber, setPageNumber] = useState(0);
    const pagesVisited=pageNumber*usersPerPage;
    const changePage=({selected})=>{
      setPageNumber(selected)
    }
    // const display=post1.slice(pagesVisited,pagesVisited+usersPerPage).map((user)=>{
    //   return(
    //     <div className="user">
    //       <p>{user.title}</p>
    //     </div>
    //   )
    // })
    useEffect(async() => {
       const res=await fetch(`${END_POINT}/post/getPost`)
       .then(res=>res.json())
       .then(data=>{
         const newArr=data.filter((data1)=>{
           if(data1.isChecked)return true
         })
         newArr.reverse()
         setPost1(newArr)
        setPost(newArr)
       })
    }, []);
    const imgLinks=[
      "https://i.ibb.co/Nx64qnr/denys-nevozhai-z0n-Vqfr-Oq-WA-unsplash.jpg",
      "https://i.ibb.co/37mYsFt/pablo-heimplatz-EAv-S-4-Kn-Grk-unsplash.jpg"
    ]
    const [search, setSearch] = useState('');
    const searchKeyword=(e)=>{
        // console.log(e.target.value);
        setSearch(e.target.value);
        
        const filteredArray=post.filter(data=>{
            if(data.title.toLowerCase().includes(e.target.value.toLowerCase())||data.author.first.toLowerCase().includes(e.target.value.toLowerCase())){
                return true;
            }
            else{
                return false;
            }
        })
         setPost1(filteredArray);
    }
  return (
      <div>
        
        <Navbar/>  
        <div  className="background ">
          <img src={imgLinks[1]} alt="s" />
        </div>
        
       <Link to="/createPost"><button style={{"border":"1px solid grey"}} className='btn btn-primary'>Create New Post</button></Link>
        <div className="container-fluid row">
{/* JSON.parse(localStorage.getItem("User")) */}
       
          <h3>Hello</h3>
          {user&&<p className='col-sm-3'>{user.email}</p>}
          {/* <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Laborum dolore est fugiat, quo minima iusto, officiis perferendis aut sed amet velit blanditiis quibusdam, repellat obcaecati ad eveniet aliquam dicta itaque?</p>
           */}
          </div>
          <div className="form-outline mb-4 container">
  <input onChange={searchKeyword} value={search}  placeholder='Search blogs by title, author' type="search" className="form-control bg-dark text-white" id="datatable-search-input"/>
  <label className="form-label">Search</label>
</div>
<ReactPaginate
        previousLabel="Previous"
        nextLabel="Next"
        pageCount={pageCount}
        onPageChange={changePage}
        pageClassName="page-item"
        containerClassName="pagination flex-wrap pagination-md justify-content-center"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        disabledClassname={"disabledBtns"}
        activeLinkClassName="active"
        renderOnZeroPageCount={null}
        />
          {post1.length ?<div className="">
          {post1.slice(pagesVisited,pagesVisited+usersPerPage).map((data,index)=>{
            return(
              <div className='' key={index}>
 {data.isChecked && data.author &&<PostTemplate data={data} key={index}/>}
              </div>
             
            )
          })}
          </div>:
          null
          }
          
          <ReactPaginate
        previousLabel="Previous"
        nextLabel="Next"
        pageCount={pageCount}
        onPageChange={changePage}
        pageClassName="page-item"
        containerClassName="pagination pagination-md justify-content-center"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        disabledClassname={"disabledBtns"}
        activeLinkClassName="active"
        renderOnZeroPageCount={null}
        />
          
      </div>
  )
};

export default Home;
